import { RentalFormActionTypes } from './types';
import AppState from '../../types/AppState';
import { ThunkAction } from 'redux-thunk';
import { TOGGLE_RENTAL_FORM_V2_LOADING_PRICING } from '../../constants/redux';

export const toggleLoadingPricing = (
  status: boolean,
  cancelToken: any = undefined
): ThunkAction<void, AppState, unknown, RentalFormActionTypes> => (
  dispatch
) => {
  dispatch({
    type: TOGGLE_RENTAL_FORM_V2_LOADING_PRICING,
    loadingPricing: status,
    pricingCancelToken: cancelToken
  });
};
